import { Component, OnInit } from '@angular/core';
import { LocationStatusService } from './location-status.service';
import { RoomService } from '../locations/room.service';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { GatewayStatusService } from '../gateway-status/gateway-status.service';
import { GatewaySetupService, CreatedGateway } from '../gateway-setup/gateway-setup.service';

@Component({
  selector: 'app-location-status',
  templateUrl: './location-status.component.html',
  styleUrls: ['./location-status.component.scss']
})
export class LocationStatusComponent implements OnInit {
  title = 'Location Health';

  locationId: string;
  p = 1;

  key = 'node_id';
  reverse = true;

  gatewaysCache = {};
  gateways: Array<any>;
  nodes: any;
  nodeData: any;
  term = '';
  numberOffline = 0;
  numberNotSeen = 0;
  numberOnline = 0;
  total = 0;

  constructor(
    public route: ActivatedRoute,
    private locationStatusService: LocationStatusService,
    private roomService: RoomService,
    private gatewayService: GatewayStatusService,
    private gatewaySetupService: GatewaySetupService
  ) {}

  async ngOnInit() {
    this.locationId = this.route.snapshot.params.locationid;
    this.nodes = [];
    if (this.locationId) {
      this.getLocation();
    }
  }

  getNodesForLocation(userForm: NgForm) {
    this.locationId = userForm.controls['locationId'].value;
    this.getLocation();
  }

  async getLocation() {
    const [nodesForLocation, seenGateways, createdGateways] = await Promise.all([
      this.locationStatusService.getNodesForLocation(this.locationId),
      this.gatewayService.getGateways(),
      this.gatewaySetupService.getGatewaysRaw()
    ]);
    this.nodes = nodesForLocation;
    this.gateways = this.getDecoratedGatewaysWithDescription(createdGateways, seenGateways);

    this.total = this.nodes.length;
    this.getNodeData();
    this.getRooms(this.locationId);
  }

  private getDecoratedGatewaysWithDescription(
    createdGateways: CreatedGateway[],
    seenGateways: any
  ) {
    let gatewayDescriptionMap = {};
    for (let gateway of createdGateways) {
      gatewayDescriptionMap[gateway.device_uuid] = gateway.description;
    }
    const decoratedGws = seenGateways.map(gateway => ({
      ...gateway,
      description:
        gatewayDescriptionMap[gateway.gateway_id] || 'Balena-' + gateway.gateway_id.slice(0, 6)
    }));

    return decoratedGws;
  }

  getRooms(locationId: string) {
    this.roomService.getAllRoomsP(locationId).then(rooms => {
      this.nodes.forEach(node => {
        const foundRoom = rooms.find(x => x.room_id === node.room_id);

        if (foundRoom) {
          node.room_name = 'room: ' + foundRoom.room_name;
        } else {
          node.room_name = 'Name not found';
        }
      });
    });
  }

  getAssociatedGatewayDesc(gatewayMac: string) {
    let gateway = this.gatewaysCache[gatewayMac];

    if (!gateway) {
      gateway = this.gateways.find(g => g.data.gatewayMacAddress.toString() === gatewayMac);
      if (gateway == null) {
        console.error(`GatewayMac ${gatewayMac} does not exist`);
        return `Unknown-${gatewayMac}`;
      }
      this.gatewaysCache[gatewayMac] = gateway;
    }

    return gateway.description;
  }

  getNodeData(): any {
    let nodeIds = [];
    this.nodes.forEach(node => {
      nodeIds.push(node.node_id);
    });

    this.locationStatusService.getNodeDataForNodes(nodeIds).then(result => {
      this.nodeData = result;

      let neverSeen = 0;
      let offline = 0;
      let online = 0;

      this.nodes.forEach(node => {
        const foundNode = this.nodeData.find(x => x.node_id === node.node_id);

        if (foundNode) {
          node.last_seen = foundNode.update_time * 1000;
          node.battery_level = foundNode.battery_level;
          node.boot_time = foundNode.boot_time * 1000;
          node.firmware = foundNode.firmware;
          node.last_snr = foundNode.last_snr;
          node.last_rssi = foundNode.last_rssi;
          node.associated_gateway = this.getAssociatedGatewayDesc(foundNode.associated_gateway);

          node.status = this.getStatus(node.last_seen);
          if (node.status === 'Offline') {
            offline++;
          } else {
            online++;
          }
        } else {
          node.status = 'Never Seen';
          neverSeen++;
        }
        this.numberNotSeen = neverSeen;
        this.numberOffline = offline;
        this.numberOnline = online;
      });
    });
  }

  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  private getStatus(lastSeen: number): string {
    if (lastSeen < Date.now() - 1000 * 60 * 30) {
      return 'Offline';
    }
    return 'Online';
  }

  public getCellColor(warningLevel: string): string {
    let color;
    switch (warningLevel) {
      case 'Online': {
        color = 'green';
        break;
      }
      case 'Offline': {
        color = 'orange';
        break;
      }
      case 'Never Seen': {
        color = 'red';
        break;
      }
      case 'Name not found': {
        color = 'red';
        break;
      }
      default: {
        color = 'black';
        break;
      }
    }

    return color;
  }
  public getBatteryCellColor(level: number): string {
    let color = 'green';

    if (level < 3.1) {
      color = 'red';
    } else if (level < 3.5) {
      color = 'orange';
    }

    return color;
  }

  //    SNR: green: > 0,   0 >= yellow: > = -3, -3 > red
  //RSSI: green: > -95,   -95 >= yellow: >= -105, -105> red

  public getSnrCellColor(value: number): string {
    let color = 'green';

    if (value < -3) {
      color = 'red';
    } else if (value <= 0) {
      color = 'orange';
    }

    return color;
  }
  public getRssiCellColor(value: number): string {
    let color = 'green';

    if (value < -105) {
      color = 'red';
    } else if (value <= -95) {
      color = 'orange';
    }

    return color;
  }
}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/location-status/location-status.component.ts